/**
 * @generated SignedSource<<f0c6804fca61c9c039653e243946e589>>
 * @relayHash 0c3ac12d45ed9bc8274f9cae76b24ed6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4259ae0d3302519de00e9a44d84c99a4c9a8376a826603d6e7ab5634250f8017

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { DesignDetailsPopupQuery } from './DesignDetailsPopupQuery.graphql';

const node: PreloadableConcreteRequest<DesignDetailsPopupQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4259ae0d3302519de00e9a44d84c99a4c9a8376a826603d6e7ab5634250f8017",
    "metadata": {},
    "name": "DesignDetailsPopupQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
